import { gql } from '@apollo/client';

export const postAdhesionComerciosIndex = gql`
mutation  AdhesionComerciosIndexApiRQ{
    AdhesionComerciosIndexApiRQ(input: $input)  
        @rest(type: "AdhesionComerciosIndexApiRS", path: "/api/gateway/formulariosComercios/presolicitud", method: "POST"){
          
            resultado
           mensaje
            
        }
}
`

